import { EnumValue, EnumExtensions } from './enum.consts';

export const Colours = {
  primary: '#52A8EF',
  secondary: '#FF765F',
  tertiary: '#3E424B',
  error: 'red',
};

export class PagedList<T> {
  skip: number;
  take: number;
  total: number;
  results: T[];
}

export class PagedFilter {
  take?: number;
  skip?: number;
}

export class GeoLocation {
  fullAddress: string;

  locality?: string;
  region?: string;
  state?: string;
  country?: string;

  coords?: GeoCoords;
}

export class GeoCoords {
  lat: number;
  lon: number;
}

export interface ItemPrice {
  flat?: number;
  perPerson?: number;
}

export class AdjustedItemPrice implements ItemPrice {
  flat?: number;
  perPerson?: number;
  adjustment?: number;

  static getTotal(item: AdjustedItemPrice, attendees: number): number {
    if (!item || (!item.flat && !item.perPerson && !item.adjustment)) {
      return 0;
    }
    return (item.flat || 0) + (item.perPerson || 0) * (attendees || 0) + (item.adjustment || 0);
  }
}

export interface ProductPrice extends ItemPrice {
  currencyCode: string;
}

export enum PaymentMethod {
  CreditCard = 1,
  BankDeposit = 2,
  Stripe = 3,
  Points = 4,
  GiftCard = 5,
  PayPal = 6,
  Discount = 7,
  Referral = 8,
  Partner = 9,
  GooglePay = 10,
  ApplePay = 11,
  Afterpay = 12
}

export enum PaymentType {
  Charge = 1,
  Refund = 2,
  Authorize = 3,
  ExpiredAuthorize = 4,
  CancelledAuthorize = 5,
}

export function PaymentMethodName(method: PaymentMethod): string {
  switch (method) {
    case PaymentMethod.CreditCard:
      return 'Credit Card';
    case PaymentMethod.BankDeposit:
      return 'Bank Deposit';
    case PaymentMethod.GiftCard:
      return 'Gift Card';
    case PaymentMethod.GooglePay:
      return 'Google Pay';
    case PaymentMethod.ApplePay:
      return 'Apple Pay';
    case PaymentMethod.Discount:
    case PaymentMethod.PayPal:
    case PaymentMethod.Points:
    case PaymentMethod.Stripe:
    case PaymentMethod.Referral:
    case PaymentMethod.Afterpay:
    default:
      return PaymentMethod[method];
  }
}
export const PaymentMethodValues: EnumValue<
  PaymentMethod
>[] = EnumExtensions.getMappedNamesAndValues<PaymentMethod>(PaymentMethod, PaymentMethodName);

export class Response {
  isSuccessful: boolean;
  status: number;
  message?: string;
  errors: ValidationError[];
}

export class ValidationError {
  errorMessage: string;
  fieldName: string;
  isFieldError: boolean;
}

export enum DaysOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export interface SelectOption {
  label: string;
  value: string;
}